import { CASES } from './constants';

const getInitialContactSort = () => {
    const saved = localStorage.getItem('contactSort');
    return saved ? JSON.parse(saved) : ['id', 'DESC'];
};

const initialState = {
    contacts: [],
    filterForm: {
        name: '',
    },
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    contactRange: [0, 19],
    contactSort: getInitialContactSort(),
    defaultFilterRange: [0, 19],
    itemsPerPage: 20,
    contractualPartyTypes: '',
    contractualPartyTypeOptions: [
        { value: 1, label: 'Licensor' },
        { value: 2, label: 'Licensee' },
        { value: 3, label: 'Producer' },
        { value: 4, label: 'Co-Producer' },
        { value: 5, label: 'Co-financing company' },
        { value: 6, label: 'Sales Agent' },
        { value: 7, label: 'Co-distributor' },
        { value: 8, label: 'Joint Venture' },
        { value: 9, label: 'Grantor' },
        { value: 10, label: 'Equity Investor' },
        { value: 11, label: 'Network Licensee' },
        { value: 12, label: 'Co-owner' },
        { value: 13, label: 'Contractual Party' },
    ],
    typeCodeOptions: [
        { value: 'LIC', label: 'Licensing' },
        { value: 'SRV', label: 'Servicing' },
        { value: 'PAR', label: 'Parent/Licensee' },
    ],
    isContactModalOpen: false,
};

/**
 * Reducer function to manage the contacts state in the Redux store.
 *
 * It handles actions related to updating contacts, filtering contacts,
 * and clearing contacts.
 *
 * @param {Object} state - The current state of the contacts.
 * @param {Object} action - The action dispatched to the reducer.
 * @return {Object} The new state of the contacts after applying the action.
 **/
export function contacts(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_CONTACTS: {
            if (payload.contactSort) {
                localStorage.setItem('contactSort', JSON.stringify(payload.contactSort));
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_CONTACTS_FILTER_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_CONTACTS: {
            return {
                ...initialState,
                contactSort: state.contactSort
            };
        }
        default:
            return state;
    }
}
